<template>
  <va-card title="Continuing Education">
    <div class="continuing-education-body">
      <p class="display-4 year">2024</p>
      <ul>
        <li>
          <a href="https://www.vetbehaviorcenter.com/for-trainers"
            alt="Nerd Herd"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Nerd Herd</a>
        </li>
      </ul>
      <p class="display-4 year">2023</p>
      <ul>
        <li>
          <a href="https://malenademartini.com/for-trainers/separation-anxiety-training-certificate-program/"
            alt="Separation Anxiety Training Certificate Program"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Separation Anxiety Training Certificate Program</a>
        </li>
      </ul>
      <p class="display-4 year">2022</p>
      <ul>
        <li>
          <a href="https://www.facebook.com/groups/457583376185825/"
            alt="Canine Conference in Colour"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Canine Conference in Colour</a>
        </li>
        <li>
          <a href="https://vetbehaviorcenter.punchpass.com/classes/11297966"
            alt="6 D's Relaxation (Protocol for Professionals)"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >6 D's Relaxation (Protocol for Professionals)</a>
        </li>
        <li>
          <a href="https://onlinecourses.behaviorvetsnyc.com/p/game-changer-meds"
            alt="Game Changer Meds: Trazodone, Gabapentin, Clonidine, & Benzodiazepines"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Game Changer Meds: Trazodone, Gabapentin, Clonidine, & Benzodiazepines</a>
        </li>
        <li>
          <a href="https://onlinecourses.behaviorvetsnyc.com/p/introduction-to-horse-training"
            alt="Introduction to Horse Training"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Introduction to Horse Training</a>
        </li>
      </ul>
      <p class="display-4 year">2021</p>
      <ul>
        <li>
          <a href="https://thelemonadeconference.com/"
            alt="Lemonade Conference"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >The Lemonade Conference</a>
        </li>
        <li>
          <a href="https://separationanxietydog.thinkific.com/courses/separation-anxiety-shadowing-program-three-seasons"
            alt="Separation Anxiety Shadowing Program"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Separation Anxiety Shadowing Program Seasons One, Two, and Three</a>
        </li>
      </ul>
      <p class="display-4 year">2020</p>
      <ul>
        <li>
          <a href="https://www.empowereddog.com/winter-summit"
            alt="Empowered Dog Winter Summit"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >The International Dog Trainers Winter Summit</a>
        </li>
        <li>
          <a href="https://illis.se/en/webinars/"
            alt="How to Make Your Animals Happy"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >How to Make Your Animals Happy</a>
        </li>
      </ul>
      <p class="display-4 year">2019</p>
      <ul>
        <li>
          <a href="https://www.shelterdogplay.org/"
            alt="Shelter Playgroup Alliance"
            target="_blank"
            rel="noopener noreferrer"
            class="link link-resources"
            :style="{color: this.$themes.primary}" >Shelter Playgroup Alliance Two-Day Workshop</a>
        </li>
      </ul>
    </div>
  </va-card>
</template>

<script>

export default {
  name: 'continuing-education-card',
}
</script>

<style scoped lang="scss">
  .continuing-education-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .year {
      margin: 0.8rem 0 0.4rem;
    }

    ul {
      margin-left: 0.8rem;

      li {
        list-style: circle;

        .italic {
          margin-top: 0;
          font-style: italic;
        }
      }
    }
  }

  @include media-breakpoint-up(lg) {
    .continuing-education-body {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
</style>
